/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFetchBaseQuery } from "@/redux/apiFetchBaseQuery";

export const unsubscribeEmailSlice = createApi({
	reducerPath: "unsubscribeEmailSlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["unsubscribeEmail"],
	endpoints: builder => ({
		unsubscribeEmail: builder.mutation<any, any>({
			query: FormData => ({
				url: "/pd-marketing-email/unsubscribe",
				method: "POST",
				body: FormData,
				headers: {
					accept: "application/json",
				},
			}),
		}),
	}),
});

export const { useUnsubscribeEmailMutation } = unsubscribeEmailSlice;
